import cn from 'classnames'
import get from 'lodash/get'
import { If } from 'components/ideal-core-ui'
import s from './Panel.scss'

const Panel = ({
  title,
  titleIcon,
  className = '',
  children,
  actions = [],
  rightActions = [],
  isClosed,
  isBodyOnly,
  styles = {}
}) => {
  const previewDashboard = get(window, 'credentials.user.previewDashboard')

  return (
    <div className={`${previewDashboard ? 'box' : s.container} ${className}`} style={styles}>
      <If condition={!isBodyOnly}>
        <header
          className={cn(previewDashboard ? 'box-header' : s.boxHeader, {
            [s.closedPanel]: isClosed
          })}
        >
          {titleIcon}
          <h2 className={s.title}>{title}</h2>
          <span className={s.actions}>{actions.map(el => el)}</span>
          <span className={s.rightActions}>{rightActions.map(el => el)}</span>
        </header>
      </If>
      <main
        className={cn(previewDashboard ? 'box-content' : s.panelWrapper, {
          [s.isBodyOnly]: isBodyOnly
        })}
        style={styles}
      >
        {children}
      </main>
    </div>
  )
}

export default Panel
